import React from 'react';
import { motion } from 'framer-motion';
import { Wifi, Bell, ClipboardList, Play } from 'lucide-react';

export interface QuickAction {
  id: string;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export interface QuickActionsProps {
  actions?: QuickAction[];
  className?: string;
}

const defaultActions: QuickAction[] = [
  { id: 'wifi', label: 'Connect to WiFi', icon: <Wifi className="w-5 h-5" />, onClick: () => {} },
  { id: 'reception', label: 'Reception', icon: <Bell className="w-5 h-5" />, onClick: () => {} },
  { id: 'room-service', label: 'Room Service', icon: <ClipboardList className="w-5 h-5" />, onClick: () => {} },
  { id: 'tour', label: 'Take Room Tour', icon: <Play className="w-5 h-5" />, onClick: () => {} },
];

export const QuickActions: React.FC<QuickActionsProps> = ({
  actions = defaultActions,
  className = '',
}) => {
  return (
    <div className={`flex gap-4 ${className}`}>
      {actions.map((action) => (
        <motion.button
          key={action.id}
          onClick={action.onClick}
          className="
            bg-white text-[#333333] rounded-[32px] px-7 py-4
            shadow-[0_2px_8px_rgba(0,0,0,0.1)]
            hover:shadow-[0_4px_16px_rgba(0,0,0,0.12)]
            flex items-center gap-3
            focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4A054]
          "
          whileHover={{ y: -2 }}
          whileTap={{ scale: 0.98 }}
          transition={{ duration: 0.2 }}
        >
          <span className="text-[#D4A054] flex items-center justify-center">
            {action.icon}
          </span>
          <span className="text-sm font-medium whitespace-nowrap">
            {action.label}
          </span>
        </motion.button>
      ))}
    </div>
  );
};

export default QuickActions;
